export default "__VITE_ASSET__b39a9bf1__"